import React from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "./FallbackComponent";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

import "./css/_custom.scss";

import HomePage from "./HomePage";
import SectionPageBody from "root/Questions/SectionPageBody";
import StandardQuestionPageBody from "root/Questions/StandardQuestionPageBody";
import HistoryPageBody from "root/HistoryPageBody";
import UserManagePageBody from "root/Management/UserManagePageBody";
import AdminSchoolPageBody from "root/AdminSchoolPageBody";
import GuidancePageBody from "root/GuidancePageBody";
import AdminDashboardPageBody from "root/AdminDashboardPageBody";
import LoginPage from "root/LoginPage";
import AdminInboxPageBody from "root/AdminInboxPageBody";
import TeacherDashboardPageBody from "root/TeacherDashboardPageBody";
import ReportsPageBody from "root/Reporting/ReportsPageBody";
import AdminRAGReportPage from "root/AdminRAGReportPage";
import TeacherRAGReportPage from "root/TeacherRAGReportPage";
import DocumentsPageBody from "root/DocumentsPageBody";
import AdminSchoolDetailPageBody from "root/AdminSchoolDetailPageBody";
import AboutUsPageBody from "root/AboutUsPageBody";
import Header from "root/Header/Header";
import Footer from "root/Footer";
import AdminRagSchoolDetailReport from "root/Reporting/AdminRagSchoolDetailReport";
import GlobalProvider from "root/Contexts/GlobalProvider";
import AdminSubmittedReport from "root/Reporting/AdminSubmittedReport";
import SystemAdminPageBody from "root/SystemAdminPageBody";

const MyApp = ({dataset}) =>
{
    const PageLayout = () => (
        <>
            <Header/>
            <Outlet/>
            <Footer/>
        </>
    );

    return (
        <ErrorBoundary FallbackComponent={ FallbackComponent }>
            <GlobalProvider dataset={dataset}>
                <BrowserRouter>
                    <Routes>
                        <Route element={ <PageLayout/> }>
                            <Route exact path="/home" element={ <HomePage/> }/>
                            <Route exact path="/home/about_us" element={ <AboutUsPageBody/> }/>
                            <Route exact path="/administration" element={ <SystemAdminPageBody/> }/>
                            <Route exact path="/school" element={ <AdminSchoolPageBody/> }/>
                            <Route exact path="/inbox" element={ <AdminInboxPageBody/> }/>
                            <Route exact path="/school/:provider_id/year/:academic_year/section/:section_number" element={ <StandardQuestionPageBody/> }/>
                            <Route exact path="/school/:provider_id/year/:academic_year/section/" element={ <SectionPageBody/> }/>
                            <Route exact path="/school/:provider_id/detail" element={ <AdminSchoolDetailPageBody/> }/>
                            <Route exact path="/school/:provider_id/history" element={ <HistoryPageBody/> }/>
                            <Route exact path="/school/:provider_id/year/:academic_year/section" element={ <SectionPageBody/> }/>
                            <Route exact path="/guidance" element={ <GuidancePageBody/> }/>
                            <Route exact path="/manage" element={ <UserManagePageBody/> }/>
                            <Route exact path="/dashboard" element={ <AdminDashboardPageBody/> }/>
                            <Route exact path="/school/:provider_id/documents" element={ <DocumentsPageBody/> }/>
                            <Route exact path="/dashboard/rag_report/:section_number" element={ <AdminRAGReportPage/> }/>
                            <Route exact path="/dashboard/rag_report/:section_number/:table_question_id" element={ <AdminRagSchoolDetailReport/> }/>
                            <Route exact path="/school/:provider_id/dashboard/rag_report" element={ <TeacherRAGReportPage/> }/>
                            <Route exact path="/school/:provider_id/dashboard" element={ <TeacherDashboardPageBody/> }/>
                            <Route exact path="/reports" element={ <ReportsPageBody/> }/>
                            <Route exact path="/reports/admin/:submitted_status/:academic_year" element={ <AdminSubmittedReport/> }/>
                        </Route>
                        <Route exact path="/" element={ <LoginPage/> }/>
                        <Route path="*" element={ <LoginPage/> }/>
                    </Routes>
                </BrowserRouter>
            </GlobalProvider>
            <div style={ { visibility: 'hidden' } } id='chartdiv'/>
        </ErrorBoundary>
    )
}

const container = document.getElementById ( 'homepage' );

const atts = container.dataset ;

const root = createRoot ( container );
root.render ( <MyApp dataset={atts}/> );
